// 资产台账
import request from '@/api/request'

export function fetchList(params) {
    return request({
        url: '/model-analysis/asset/material/listAvailable',
        params,
    })
}